import { Button } from "@newsela/angelou";
import PropTypes from "prop-types";

import { withTrackEvent, actionNames, actionPrefixes } from "@newsela/snitch";
import useEventProperties from "../../Actions/utils/useEventProperties";

const ButtonWithTrackEvent = withTrackEvent(Button);

const propTypes = {
  annotationId: PropTypes.number,
  buttonStatusColor: PropTypes.string,
  commentDeleteConfirmationButtonRef: PropTypes.object,
  handleDelete: PropTypes.func,
  isActionPending: PropTypes.bool,
  __cssFor: PropTypes.object,
};

const DeleteConfirmationButton = ({
  annotationId,
  commentDeleteConfirmationButtonRef,
  handleDelete,
  isActionPending,
}) => {
  const description = "Delete annotation comment";
  const eventProperties = useEventProperties(
    annotationId,
    actionNames.delete,
    description,
    actionPrefixes.initiate,
  );

  return (
    <ButtonWithTrackEvent
      disabled={isActionPending}
      onClick={handleDelete}
      ariaProps={{ "aria-label": "Delete your comment?, Delete" }}
      ref={commentDeleteConfirmationButtonRef}
      flavor={Button.flavors.danger}
      size={Button.sizes.md}
      {...eventProperties}
    >
      Delete
    </ButtonWithTrackEvent>
  );
};

DeleteConfirmationButton.propTypes = propTypes;

export default DeleteConfirmationButton;
